import Plot from "react-plotly.js";

type HistogramNewProps = {
  data: any;
  layout: any;
};

const HistogramNew = (props: HistogramNewProps) => {
    return (
      <Plot
        style={{ display: "flex", justifyContent: "center" }}
        data={props.data[0]}
        layout={props.layout}
      />
    );
  };
  
  export default HistogramNew;